import { useState } from "react";
import useSWR from "swr";
import getBCAValuation from "../api/getBCAValuation";
import useSourcePage from "./useSourcePage";
import getApiUrl from "../helpers/getApiUrl";

const useValuationEndpoint = (
  vrm: string,
  isProvisional: boolean,
  isToUseAuthZero: boolean = false,
  accessToken?: string
) => {
  const { isVPExceptSoldPageOrTransportTab } = useSourcePage();
  const [isBCAValuationLoading, setIsBCAValuationLoading] = useState(true);
  const baseUrl = getApiUrl(process.env.apiFunctionUrl || "", isToUseAuthZero);

  const bcaValuationUrl = `${baseUrl}api/vendors/pricing/valuation?requestOrigin=${
    isProvisional ? "Provisional" : "VendorPortal"
  }&vrms=${vrm}`;

  const { data: bcaValuationResult } = useSWR<string | null>(
    vrm && isVPExceptSoldPageOrTransportTab && (!isToUseAuthZero || accessToken)
      ? [bcaValuationUrl, vrm, isToUseAuthZero, accessToken]
      : null,
    getBCAValuation,
    {
      revalidateOnFocus: false,
      shouldRetryOnError: false,
      onSuccess: () => {
        setIsBCAValuationLoading(false);
      },
      onError: () => {
        setIsBCAValuationLoading(false);
      },
    }
  );

  return {
    bcaValuationResult,
    isBCAValuationLoading,
    isBCAValuationAvailable:
      bcaValuationResult !== "0" && bcaValuationResult !== null,
  };
};

export default useValuationEndpoint;
